import { vnTemplate } from "../../../../valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import videoPickerAdd_template from "./videoPickerAdd_template";
import videoPickerView_template from "./videoPickerView_template";
import videoPickerEdit_template from "./videoPickerEdit_template";
import { filterSimple_template } from "../../../../valnet_jslib/vnKnockoutJsTemplates/filterSimple_template";
import { filterDropdown_template } from "../../../../valnet_jslib/vnKnockoutJsTemplates/filterDropdown_template";
import { pagination_template } from "../../../../valnet_jslib/vnKnockoutJsTemplates/pagination_template";
import { validationsList_template } from "../../../../valnet_jslib/vnKnockoutJsTemplates/validationsList_template";
import { filterTag_template } from "../../../../../../js/components/templates/filterTag_template";
import { multipleSelector_template } from "../../../../valnet_jslib/vnKnockoutJsTemplates/multipleSelector_template";

declare var ko: any;
declare var Waypoint: any;

export default class videoPicker_template extends vnTemplate {
    public validations: validationsList_template;

    protected filterSimple: filterSimple_template;
    protected ratioFilter_template: filterDropdown_template;
    protected orientationFilter_template: filterDropdown_template;
    protected videoPagination_template: pagination_template;

    public videoPickerView: videoPickerView_template;
    public videoPickerAdd: videoPickerAdd_template;
    public videoPickerEdit: videoPickerEdit_template;

    public tagFilter: filterTag_template;

    protected categoryFilter: multipleSelector_template;
    protected contentTypeFilter: multipleSelector_template;

    protected videoNextpageRequested;
    protected videoLoadEnable = false;

    protected buildViewModel(): any {
        const viewModel = {
            videoPickerShown: ko.observable(false),
            target: ko.observable(null),
            videos: ko.observableArray([]),
            orderBy: ko.observable("dateCreated"),
            orderByDirection: ko.observable("DESC"),
            orderByAndDirection: ko.observable("dateCreated_DESC"),
            permissions: ko.observableArray(this.initPermissions([])),

            onClickCancel: () => this.onClickCancel(),
            onDropFile: (data, event) => this.onDropFile(data, event),
            onClickAdd: (data, event) => this.onClickAdd(data, event),
            onChangeSortingFilter: (data, event) => this.onChangeSortingFilter(data, event),
            onClickQuickInsert: (param, data, event) => this.onClickQuickInsert(param, data),
            onClickEdit: (data, event) => this.onClickEdit(data),
            onClickView: (data, event) => this.onClickView(data),
            isVideoViewShown: () => this.isVideoViewShown(),
            onClickPreviewVideo: (data) => this.onClickPreviewVideo(data),
        };

        const embargoPermissions = ko.pureComputed(() => {
            const permissions = viewModel.permissions()["article_edit_embargo"];
            const { read = false, write = false } = permissions || {};
            return { read, write };
        });

        return { ...viewModel, embargoPermissions };
    }

    protected getTemplateHtml(): string {
        return `
<div class="w-lightbox w-img-picker video" data-bind="css: { 'is-visible': videoPickerShown }">

    <div class="lightbox-content img-picker">

        <div class="img-picker-header w-justify">
            <div class="w-left">
                <div class="header-droparea" data-bind="event: { drop: onDropFile }">
                    <button class="btn secondary icon i-video-2" type="button" data-bind="event: { click: onClickAdd }">Add Video</button>
                </div>
            </div>
            <div class="w-center"><span class="picker-header-title icon i-video-2">Video Picker</span></div>
            <div class="w-right"></div>
            <button type="button" class="close-btn icon i-close" data-bind="event: { click: onClickCancel }"></button>
        </div>

        <div class="img-picker-body">
            ${this.validations.getHtmlBuild()}

            <div class="list-header w-justify">
                <div class="w-left">
                    ${this.categoryFilter.getHtmlBuild()}
                    ${this.contentTypeFilter.getHtmlBuild()}
                    ${this.tagFilter.getHtmlBuild()}
                    <div><label class="form-label form-label-box">Orientation</label> ${this.orientationFilter_template.getHtmlBuild()} </div>&nbsp;&nbsp;
                    <div ><label class="form-label form-label-box">Ratio</label> ${this.ratioFilter_template.getHtmlBuild()}</div>
                </div>
            </div>


            <div class="list-header w-justify w-sorting">
                <div class="w-left"></div>
                <div class="w-center">${this.filterSimple.getHtmlBuild()}</div>
                <div class="w-right">
                    <div class="form-group row">
                        <select class="small" data-bind="value: orderByAndDirection, event: { change: onChangeSortingFilter }">
                            <option value="dateCreated_DESC">Newest</option>
                            <option value="dateCreated_ASC">Oldest</option>
                            <option value="title_ASC">Alphabetical A->Z</option>
                            <option value="title_DESC">Alphabetical Z->A</option>
                        </select>
                    </div>
                 </div>
            </div>


            <div id="filters-selected-2" class="selected-filters">
                <div id="selected-tags_video"></div>
                <div id="selected-categories_video"></div>
                <div id="selected-content_types_video"></div>
            </div>

            <div class="w-img-picker-list" data-bind="css : { 'is-short' : isVideoViewShown() }">
                <div class="w-img-msg" data-bind="css: { 'is-visible': videos().length == 0}">
                    <p>No Videos Found</p>
                </div>

                <ul id="video-results-list" class="img-picker-list search image" data-bind="foreach: videos, css: { 'single-picker' : 1 }" style="height: auto;">
                    <!-- ko if: (!$data.isUnderEmbargo || $parent.embargoPermissions().read) -->
                        <li class="img-picker-item icon">
                        <div class="w-picker-list-title">
                            <span class="picker-list-title" data-bind="text: title"></span>
                        </div>
                        <button class="btn-zone view"  title="view image" type="button" data-bind="event: { click: $parent.onClickView }"><span>view image</span></button>
                        <div class="dropdown">
                            <div class="dropdown-list">

                                <button class="btn-icon icon i-ins-ind" title="Insert Individually" type="button" data-bind="event: { click: $parent.onClickQuickInsert.bind($parent, 'insert') }"><span>Insert Individually</span></button>
                                <button class="btn-icon icon i-edit" title="Edit" type="button" data-bind="event: { click: $parent.onClickEdit }"><span>Edit</span></button>
                                <button class="btn-icon icon i-full-size" title="Full Size" type="button" data-bind="click : $parent.onClickPreviewVideo"><span>Full Size</span></button>

                            </div>
                        </div>
                        <div class="ratio-content">
                            <span class="picker-list-duration" data-bind="text : length"></span>
                            <img data-bind="attr: {src: thumbnail ? thumbnail.url : '/assets/images/replace-video.png', width : 142, height : 82  }">
                            <!-- <video data-bind="attr: {src: url, width : 142, height : 82  , poster : thumbnail ? thumbnail.url : '/assets/images/replace-video.png' }"> -->
                        </div>

                    </li>
                    <!-- /ko -->
                </ul>
            </div>

        </div>

        ${this.videoPickerAdd.getHtmlBuild()}
        ${this.videoPickerEdit.getHtmlBuild()}
        ${this.videoPickerView.getHtmlBuild()}

    </div>

</div>`;
    }

    protected getTemplateName(): string {
        return "videoPicker-template";
    }

    protected getMainElementType(): string {
        return "div";
    }

    protected getMainElementClasses(): Array<string> {
        return [];
    }

    protected initPartial() {
        this.validations = new validationsList_template(
            "validationList_video",
            this.getTemplateViewModel(),
            this.caller,
        );

        this.filterSimple = new filterSimple_template("videoKeywordFilter", this.getTemplateViewModel(), this.caller);

        this.videoPickerAdd = new videoPickerAdd_template("videoAdd", this.getTemplateViewModel(), this.caller);
        this.videoPickerAdd.setParent(this);

        this.videoPickerEdit = new videoPickerEdit_template("videoEdit", this.getTemplateViewModel(), this.caller);
        this.videoPickerEdit.setParent(this);

        this.videoPickerView = new videoPickerView_template("videoView", this.getTemplateViewModel(), this.caller);
        this.videoPickerView.setParent(this);

        this.ratioFilter_template = new filterDropdown_template(
            "videoRatioFilter",
            this.getTemplateViewModel(),
            this.caller,
        );
        this.ratioFilter_template.setLabel("Ratio");

        this.orientationFilter_template = new filterDropdown_template(
            "videoOrientationFilter",
            this.getTemplateViewModel(),
            this.caller,
        );
        this.orientationFilter_template.setLabel("Orientation");

        this.videoPagination_template = new pagination_template("videoPagination", this.getTemplateViewModel(), this);
        this.videoPagination_template.getTemplateViewModel().itemPerPage = 36;
        this.videoPagination_template.setNumberItemToPaginate(36);

        this.tagFilter = new filterTag_template("filterVideoTag", this.getTemplateViewModel(), this.caller);
        this.tagFilter.asMultipleSelectionMode();
        this.tagFilter.setTagContainerId("selected-tags_video");
        this.tagFilter.setTagContainerCaption("Selected tags:");

        this.categoryFilter = new multipleSelector_template("categoryVideoFilter", this.getTemplateViewModel(), this.caller);
        this.categoryFilter.setLabel("category");
        this.categoryFilter.setFilterContainerClass("margin-neg");
        this.categoryFilter.setTagContainerId("selected-categories_video");
        this.categoryFilter.setTagContainerCaption("Selected categories:");

        this.contentTypeFilter = new multipleSelector_template(
            "contentTypeVideoFilter",
            this.getTemplateViewModel(),
            this.caller,
        );
        this.contentTypeFilter.setLabel("content type");
        this.contentTypeFilter.setFilterContainerClass("margin-neg");
        this.contentTypeFilter.setTagContainerId("selected-content_types_video");
        this.contentTypeFilter.setTagContainerCaption("Selected content types:");
    }

    public setCaller(caller) {
        this.caller = caller;
        this.categoryFilter.caller = caller;
        this.contentTypeFilter.caller = caller;
        this.tagFilter.caller = caller;
        this.videoPagination_template.caller = caller;
        this.videoPickerView.caller = caller;
    }

    getViewModelForRequest() {
        return {
            filters: {
                keywords: this.getTemplateViewModel().videoKeywordFilter.filterKeyword,
                ratio: this.getTemplateViewModel().videoRatioFilter.selectedOption,
                orientation: this.getTemplateViewModel().videoOrientationFilter.selectedOption,
                tags: this.tagFilter.getTagsForRequest(),
                categories: this.categoryFilter.getSelectedItems(),
                contentTypes: this.contentTypeFilter.getSelectedItems(),
            },
            videoPagination: this.getTemplateViewModel().videoPagination,
            orderBy: this.getTemplateViewModel().orderBy,
            orderByDirection: this.getTemplateViewModel().orderByDirection,
        };
    }

    toggleModal() {
        this.getTemplateViewModel().videoPickerShown(!this.getTemplateViewModel().videoPickerShown());
    }

    show() {
        if (!document.body.classList.contains("is-fixed")) {
            document.body.classList.add("is-fixed");
        }
        this.getTemplateViewModel().videoPickerShown(true);
    }

    hide() {
        document.body.classList.remove("is-fixed");
        this.getTemplateViewModel().videoPickerShown(false);
        this.resetPagination();
        this.resetFilter();
        this.videoPickerEdit.setVideoCardElement(null);
        this.validations.clearMessages();
    }

    isShown() {
        return this.getTemplateViewModel().videoPickerShown() === true;
    }

    onClickCancel() {
        if (this.videoPickerView.isShown()) {
            this.hideVideoPickerView();
        }
        this.hide();
    }

    onClickAdd(data, event): any {
        this.videoPickerAdd.toggleModal();
        this.setVideoCardElement(null);
    }

    onDropFile(data, event): any {
        this.videoPickerAdd.toggleModal();
        this.videoPickerAdd.onDropVideoFiles(data, event);
        this.setVideoCardElement(null);
    }

    hideVideoPickerAdd() {
        this.videoPickerAdd.hide();
    }

    showVideoPickerAdd() {
        this.videoPickerAdd.show();
    }

    hideVideoPickerEdit() {
        this.videoPickerEdit.hide();
    }

    showVideoPickerEdit() {
        this.videoPickerEdit.show();
    }

    hideVideoPickerView() {
        this.videoPickerView.hide();
    }

    showVideoPickerView() {
        this.videoPickerView.show();
    }

    setVideoPickerEditData(data, extra?) {
        this.videoPickerEdit.setData(data, extra);
    }

    getThumbnailImage() {
        return this.videoPickerEdit.thumbnailImageWidget.getImage();
    }

    setThumbnailImage(image) {
        this.videoPickerEdit.thumbnailImageWidget.setImage(image);
    }

    clearThumbnailImage() {
        this.videoPickerEdit.thumbnailImageWidget.clearImage();
    }

    insertVideo(param?, data?) {
        let target = this.getTemplateViewModel().target();
        this.caller.insertVideo(param, target, data);
    }

    onChangeSortingFilter(data, event): any {
        if (event.target.value.includes("DESC")) {
            data.orderByDirection("DESC");
        } else {
            data.orderByDirection("ASC");
        }

        //TODO : name or title
        if (event.target.value.includes("name")) {
            data.orderBy("name");
        } else {
            data.orderBy("dateCreated");
        }

        this.resetPagination();

        this.caller.getVideosData();
    }

    setTarget(editorName) {
        this.getTemplateViewModel().target(editorName);
    }

    getTarget() {
        return this.getTemplateViewModel().target();
    }

    public setVideoPagination(pagination) {
        this.videoPagination_template.getTemplateViewModel().pageMax(pagination.totalPage);
        this.videoPagination_template.getTemplateViewModel().pageNumber(pagination.currentPage);
    }

    setVideos(videos) {
        if (this.videoPagination_template.getTemplateViewModel().pageNumber() == 1) {
            this.getTemplateViewModel().videos([]);
        }
        if (videos.length > 0) {
            let vids = this.getTemplateViewModel().videos().concat(videos);
            this.getTemplateViewModel().videos(vids);

            this.videoNextpageRequested = false;
            if (!this.videoLoadEnable) {
                this.enableVideoWaypoint();
            }
        }
    }

    setRatios(ratios) {
        this.ratioFilter_template.setOptions(ratios);
    }

    setOrientations(orientations) {
        this.orientationFilter_template.setOptions(orientations);
    }

    setTagFilter(tags) {
        this.tagFilter.setTags(tags);
    }

    enableVideoWaypoint() {
        var div = document.getElementById("video-results-list");
        let self = this;

        var locked = false;
        var lastCall = 0;

        if (div) {
            div.addEventListener("scroll", function (event) {
                if (locked) return;

                if (lastCall) clearTimeout(lastCall);
                lastCall = setTimeout(() => {
                    if (self) {
                        self.runOnScroll(event, lastCall, locked, self, div);
                    }
                }, 200);
                if (
                    document.body.classList.contains("is-fixed") &&
                    div.scrollTop != 0 &&
                    div.scrollTop + div.clientHeight >= div.scrollHeight - 100 &&
                    !self.videoNextpageRequested
                ) {
                    if (
                        self.videoPagination_template.getTemplateViewModel().pageNumber() <
                        self.videoPagination_template.getTemplateViewModel().pageMax()
                    ) {
                        self.videoPagination_template
                            .getTemplateViewModel()
                            .pageNumber(self.videoPagination_template.getTemplateViewModel().pageNumber() + 1);
                        self.caller.getVideosData();
                        self.videoNextpageRequested = true;
                    }
                }

                locked = false;
            });
            this.videoLoadEnable = true;
        }
    }

    runOnScroll(event, lastCall, locked, self, div) {
        if (locked) return;

        if (lastCall) clearTimeout(lastCall);
        lastCall = setTimeout(() => {
            if (self) {
                self.runOnScroll(event, lastCall, locked, self);
            }
        }, 200);

        locked = false;
    }

    saveVideo(videoData, param?) {
        this.caller.saveVideo(videoData, param);
    }

    public showLoading() {
        let lists = document.getElementsByClassName("w-img-picker-list");
        for (let list of lists) {
            list.classList.add("loading");
        }
    }

    public hideLoading() {
        let lists = document.getElementsByClassName("w-img-picker-list");
        for (let list of lists) {
            list.classList.remove("loading");
        }
    }

    public showLoadingEditVideo() {
        let lists = document.getElementsByClassName("w-img-picker-form");
        for (let list of lists) {
            list.classList.add("loading");
        }
    }

    public hideLoadingEditVideo() {
        let lists = document.getElementsByClassName("w-img-picker-form");
        for (let list of lists) {
            list.classList.remove("loading");
        }
    }

    onClickQuickInsert(param?, data?): any {
        let videoCardElement = this.videoPickerEdit.getVideoCardElement();
        let target = this.getTarget();
        if (videoCardElement) {
            this.caller.replaceOrUpdateVideoCardElement(videoCardElement, data, target);
            this.videoPickerEdit.setVideoCardElement(null);
            this.hide();
            return;
        }
        this.insertVideo(param, data);
    }

    onClickEdit(data): any {
        this.editVideo(data);
    }

    onClickView(data): any {
        this.viewVideo(data);
    }

    isVideoViewShown(): any {
        return this.videoPickerView.isShown();
    }

    resetPagination() {
        this.getTemplateViewModel().videoPagination.pageNumber(1);
        this.getTemplateViewModel().videos([]);
        this.videoLoadEnable = null;
    }

    resetFilter() {
        this.getTemplateViewModel().videoKeywordFilter.filterInputClearButton(0);
        this.getTemplateViewModel().videoKeywordFilter.filterKeyword("");
        this.getTemplateViewModel().videoRatioFilter.selectedOption(null);
        this.getTemplateViewModel().videoOrientationFilter.selectedOption(null);
    }

    insertImage(image, extra_mode) {
        let target = this.getTemplateViewModel().target();
        this.caller.insertImage(image, target, extra_mode);
        this.hide();
    }

    setEditVideoData(video) {
        this.videoPickerEdit.setVideoData(video);
    }

    setViewVideoData(video) {
        this.videoPickerView.setVideoData(video);
    }

    editVideo(data) {
        this.hideVideoPickerAdd();
        this.hideVideoPickerView();
        this.setEditVideoData(data);
        this.showVideoPickerEdit();
    }

    viewVideo(data): any {
        this.videoPickerView.setVideoData(data);
        this.videoPickerView.show();
    }

    deleteVideo(data) {
        this.caller.deleteVideo(data);
    }

    setValidationMessageOnAddVideo(messages) {
        this.videoPickerAdd.validations.setMessages(messages);
    }

    getVideoPickerTarget() {
        return this.getTemplateViewModel().target();
    }

    setUploadValue(value: number) {
        this.videoPickerAdd.setUploadValue(value);
    }

    setUploadIsInProgress(value: boolean) {
        this.videoPickerAdd.setUploadIsInProgress(value);
    }

    setVideoCardElement(element) {
        this.videoPickerEdit.setVideoCardElement(element);
    }

    onClickPreviewVideo(data): any {
        window.open(data.url, "_blank");
    }

    clearVideoFileInput() {
        this.videoPickerAdd.clearVideoFileInput();
    }

    getVideoIsNotUploadable() {
        return this.videoPickerAdd.getVideoIsNotUploadable();
    }

    getFileIsVideo() {
        return this.videoPickerAdd.getFileIsVideo();
    }

    setValidationMessage(messages) {
        this.validations.setMessages(messages);
    }
    setPermissions(permissions) {
        this.getTemplateViewModel().permissions(permissions);
    }

    getPermissions() {
        return this.getTemplateViewModel().permissions();
    }

    public setCategoryFilter(items) {
        this.categoryFilter.setItems(items);
    }

    public setContentTypeFilter(items) {
        this.contentTypeFilter.setItems(items);
    }

    public setFilterSelectedItems(objFilter, urlParams) {
        let splitString = [];

        // Multi select filters.
        if (Array.isArray(urlParams)) {
            urlParams = urlParams.toString();
        }
        if (urlParams) {
            if (typeof urlParams == "string") {
                splitString = urlParams.split(",");
            } else {
                splitString = [urlParams];
            }
            let arrayParam = [];
            let idTagArray = [];
            splitString.forEach((id) => {
                if (!isNaN(Number(id))) {
                    id = Number(id);
                } else {
                    id = id.replaceAll("+", " ");
                }
                arrayParam.push({ id: id });
                idTagArray.push(id);
            });
            objFilter.setSelectedItems(arrayParam);
            objFilter.setTags(idTagArray, objFilter.getItems());
        } else {
            objFilter.setSelectedItems([]);
            objFilter.setTags([], objFilter.getItems());
        }
    }

    protected downloadSubtitle(url){
        window.open(url, '_blank');
    }
}



// WEBPACK FOOTER //
// ./vendor/valnet/valnet_imagePicker/js/components/templates/videoPicker_template.ts